import { formatNumberOrString, formatNumberOrStringAfterTwoDecimals } from "../../Components/components.utils";
import { GET_USER_PROFILE, SET_LOGIN, SET_USER_PROFILE, SET_ROLE, SET_LOCATIONS, SET_LOADER, LOGOUT, SET_NOTIFICATIONS, SET_CHAT_HISTORY, FETCH_PROFILE, SET_SELLER_ORDER_TAKING_STATUS } from "../actionTypes";
import { USER_ACTION_TYPES } from "../actions/user.action";
export const dashboardDetails = {
	bidAwardRatio: 0,
	deliveriesScheduled: "-",
	newNotification: "-",
	newOpenBidRequest: "-",
	openOrdersAwardedToYou: "-",
	ordersToDate: "-",
	rating: 0,
}

const initialState = {
	profileData: {
		dwollaCustomerId: "",
		tokenAcc: []
	},
	role: "",
	isLoggedIn: false,
	locations: [],
	loader: false,
	notifications: [],
	chatHistory: [],
	dashboardDetails: {
		bidAwardRatio: 0,
		deliveriesScheduled: "-",
		newNotification: "-",
		newOpenBidRequest: "-",
		openOrdersAwardedToYou: "-",
		ordersToDate: "-",
		rating: 0,
	},
	closedMarketDashboardDetails: {
		bidAwardRatio: 0,
		deliveriesScheduled: "-",
		newNotification: "-",
		newOpenBidRequest: "-",
		openOrdersAwardedToYou: "-",
		ordersToDate: "-",
		rating: 0,
	},
	isLoading: false,
};

const userReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_USER_PROFILE: {
			return { ...state.profileData };
		}

		case SET_USER_PROFILE: {
			return { ...state, profileData: { ...state.profileData, ...action.payload } };
		}

		case FETCH_PROFILE: {
			action.payload.totalCredit = formatNumberOrString(action.payload.totalCredit);
			action.payload.totalUsedCredit = formatNumberOrString(action.payload.totalUsedCredit);
			action.payload.totalAvailableCredit = formatNumberOrString(action.payload.totalAvailableCredit);
			return { ...state, profileData: { ...state.profileData, ...action.payload } };
		}

		case USER_ACTION_TYPES.GET_CREDITS_DATA: {
			return state;
		}

		case USER_ACTION_TYPES.GET_CREDITS_DATA_DONE: {
			if (state.profileData.totalAvailableCredit === action.payload.creditData.overall.available) return state;
			const newState = structuredClone(state);
			newState.profileData.totalCredit = formatNumberOrString(action.payload.creditData.overall.credit);
			newState.profileData.totalUsedCredit = formatNumberOrString(action.payload.creditData.overall.used);
			newState.profileData.totalAvailableCredit = formatNumberOrString(action.payload.creditData.overall.available);

			return newState;
		}

		case SET_LOGIN: {
			state.isLoggedIn = action.payload;
			return { ...state };
		}

		case SET_ROLE: {
			state.role = action.payload;
			return { ...state };
		}

		case SET_LOCATIONS: {
			state.locations = action.payload;
			return { ...state };
		}

		case SET_LOADER: {
			state.loader = action.payload;
			return { ...state };
		}

		case LOGOUT: {
			return { profileData: {}, role: "", isLoggedIn: false, locations: [], loader: false };
		}

		case SET_NOTIFICATIONS: {
			state.notifications = action.payload;
			return { ...state };
		}

		case SET_CHAT_HISTORY: {
			state.chatHistory = action.payload;
			return { ...state };
		}

		case SET_SELLER_ORDER_TAKING_STATUS: {
			state.profileData.isActive = action.payload;
			return structuredClone(state);
		}

		case USER_ACTION_TYPES.GET_DASHBOARD_DETAILS: {
			state.isLoading = true;
			return structuredClone(state);
		}

		case USER_ACTION_TYPES.GET_DASHBOARD_DETAILS_ERROR: {
			state.isLoading = false;
			return structuredClone(state);
		}

		case USER_ACTION_TYPES.GET_DASHBOARD_DETAILS_DONE: {
			state.isLoading = false;
			const { bidAwardRatio, deliveriesScheduled, newNotification, newOpenBidRequest, openOrdersAwardedToYou, ordersToDate, rating, marketType, ...rest } = action.payload;
			const newDashboardDetails = {
				bidAwardRatio: formatNumberOrStringAfterTwoDecimals(bidAwardRatio),
				deliveriesScheduled: formatNumberOrString(deliveriesScheduled),
				newNotification: formatNumberOrString(newNotification),
				newOpenBidRequest: formatNumberOrString(newOpenBidRequest),
				openOrdersAwardedToYou: formatNumberOrString(openOrdersAwardedToYou),
				ordersToDate: formatNumberOrString(ordersToDate),
				rating: formatNumberOrStringAfterTwoDecimals(rating),
				...rest
			};
			if (marketType === "closed") {
				state.closedMarketDashboardDetails = newDashboardDetails;
			} else {
				state.dashboardDetails = newDashboardDetails;
			}
			return structuredClone(state);
		}

		case USER_ACTION_TYPES.SET_USER_PROFILE_PICTURE: {
			state.isLoading = true;
			return structuredClone(state);
		}

		case USER_ACTION_TYPES.SET_USER_PROFILE_PICTURE_DONE: {
			state.isLoading = false;
			state.profileData.profileImage = action.payload.image;
			return structuredClone(state);
		}

		case USER_ACTION_TYPES.SET_USER_PROFILE_PICTURE_ERROR: {
			state.isLoading = false;
			return structuredClone(false)
		}

		case USER_ACTION_TYPES.SEND_EMAIL_VERIFICATION_OTP: {
			state.isLoading = true;
			return state;
		}

		case USER_ACTION_TYPES.SEND_EMAIL_VERIFICATION_OTP_DONE: {
			state.isLoading = false;
			debugger;
			return state;
		}

		case USER_ACTION_TYPES.SEND_EMAIL_VERIFICATION_OTP_ERROR: {
			state.isLoading = false;
			return state;
		}

		case USER_ACTION_TYPES.ADD_UNVERIFIED_ACCOUNT_DATA_FROM_ACCESS_TOKEN: {
			state.isLoading = true;
			return state;
		}

		case USER_ACTION_TYPES.ADD_UNVERIFIED_ACCOUNT_DATA_FROM_ACCESS_TOKEN_DONE: {
			state.isLoading = false;
			state.profileData.tokenAcc = action.payload;
			return structuredClone(state);
		}

		case USER_ACTION_TYPES.ADD_UNVERIFIED_ACCOUNT_DATA_FROM_ACCESS_TOKEN_ERROR: {
			state.isLoading = false;
			return state;
		}

		default:
			return state;
	}
};

export default userReducer;
